import { Injectable } from '@angular/core';

import { Http, Response, RequestOptions, Headers } from '@angular/http';
import 'rxjs/add/operator/catch';
import { Observable } from 'rxjs/Observable';
import { UtilitiesService } from '../services/utilities.service';
import { Imagen } from '../model/imagen';


@Injectable()
export class SubirImagenesService {

  constructor(
    private _http: Http,
    private _utilities: UtilitiesService
  ) { }

  public upload(data: Imagen[]) {
    let json = { "Metodo": "uploadImage", "Datos": data };
    let params = "Data=" + this._utilities.getEscapeString(JSON.stringify(json));
    let headers = new Headers({ 'Content-Type': 'application/x-www-form-urlencoded' });

    return this._http.post(this._utilities.getURL("post"),
      params, { headers: headers }).map(res => res.json());
  }

   public getImagenes(query:any): Observable<Imagen[]> {
    let json = { "Metodo": "getImagenes", "Datos": query };
    let params = "Data=" + this._utilities.getEscapeString(JSON.stringify(json));
    let headers = new Headers({ 'Content-Type': 'application/x-www-form-urlencoded' });

    return this._http.post(this._utilities.getURL("get"),
      params, { headers: headers }).map(res => res.json());
  }

}



// WEBPACK FOOTER //
// D:/TPL ILG/3PL_ILG/src/app/services/subir-imagenes.service.ts